import {useSearchParams} from 'react-router-dom';
import {useForm} from 'react-hook-form';
import {FormTextField} from '../../ui/forms/input-field/text-field/text-field';
import {Form} from '../../ui/forms/form';
import {AuthLayout} from './auth-layout/auth-layout';
import {
  SendPasswordResetEmailPayload,
  useSendPasswordResetEmail,
} from '../requests/send-reset-password-email';
import {Trans} from '../../i18n/trans';
import {StaticPageTitle} from '../../seo/static-page-title';
import {useSettings} from '../../core/settings/use-settings';
import {
  AuthCard,
  AuthCardWrap,
  AuthCloseButton,
  AuthShell,
  AuthTitle,
  authFieldClass,
  authPrimaryBtnClass,
} from './auth-ui';
import {resolveSiteLogoSrc} from '@common/branding/site-logo';
import {useIsDarkMode} from '@common/ui/themes/use-is-dark-mode';

export function ForgotPasswordPage() {
  const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();

  const [searchParams] = useSearchParams();
  const searchParamsEmail = searchParams.get('email') || undefined;

  const form = useForm<SendPasswordResetEmailPayload>({
    defaultValues: {email: searchParamsEmail},
  });
  const sendEmail = useSendPasswordResetEmail(form);
  const logoSrc = resolveSiteLogoSrc(branding, isDarkMode);

  return (
    <AuthLayout>
      <StaticPageTitle>
        <Trans message="Forgot Password" />
      </StaticPageTitle>
      <AuthShell logoSrc={logoSrc}>
        <AuthCardWrap
          action={<AuthCloseButton to="/login" />}
        >
          <AuthCard>
            <AuthTitle>
              <Trans message="Reset password" />
            </AuthTitle>

            <Form
              form={form}
              onSubmit={payload => {
                sendEmail.mutate(payload);
              }}
            >
              <div className="flex w-full flex-col items-center gap-[24px]">
                <p className="w-[350px] max-w-full text-center text-[16px] font-normal leading-normal text-[#4C4C4C] dark:text-[#b3bcc8]">
                  <Trans message="Enter your email address below and we will send you a link to reset or create your password." />
                </p>

                <FormTextField
                  name="email"
                  type="email"
                  label={null}
                  placeholder="Email"
                  disabled={!!searchParamsEmail}
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck={false}
                  className="w-[350px] max-w-full"
                  inputClassName={authFieldClass}
                  required
                />

                <button
                  type="submit"
                  className={authPrimaryBtnClass}
                  disabled={sendEmail.isLoading}
                  aria-label="Continue"
                >
                  <Trans message="Continue" />
                </button>
              </div>
            </Form>
          </AuthCard>
        </AuthCardWrap>
      </AuthShell>
    </AuthLayout>
  );
}
